const S3_ASSETS = {
  CERTIFICATE: "https://markoknow.s3.ap-south-1.amazonaws.com/static/org/certificate.png",
  COMMUNITY: "https://markoknow.s3.ap-south-1.amazonaws.com/static/org/community.png",
  HERO: "https://markoknow.s3.ap-south-1.amazonaws.com/static/org/heropic.png",
  MENTOR: "https://markoknow.s3.ap-south-1.amazonaws.com/static/org/mentor.png",
  MENTORSHIP: "https://markoknow.s3.ap-south-1.amazonaws.com/static/org/mentorship.png",
  NETWORKING: "https://markoknow.s3.ap-south-1.amazonaws.com/static/org/networking.png",
  SKILL: "https://markoknow.s3.ap-south-1.amazonaws.com/static/org/skill.png",
  STATS: "https://markoknow.s3.ap-south-1.amazonaws.com/static/org/stats.png",
  WORKSHOP: "https://markoknow.s3.ap-south-1.amazonaws.com/static/org/workshop.png"
};
export default S3_ASSETS;